import React, { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify"; // Import toast

// Use the environment variable for the API base URL
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

function AddOrganization() {
  const [organizationName, setOrganizationName] = useState("");
  const [organizationBRN, setOrganizationBRN] = useState("");
  const [organizationOwnerName, setOrganizationOwnerName] = useState("");
  const [generatedOrganizationCode, setGeneratedOrganizationCode] = useState(null); // State to hold the generated unit code
  const [organizationPrefix, setOrganizationPrefix] = useState("");

 
  // Handle form submission
  const handleAddOrganization = async () => {

    // validate organization prefix
    if (!/^[A-Z]{3}$/.test(organizationPrefix)) {
      toast.error("Organization code must be exactly 3 uppercase letters.");
      return;
    }

    // Validate required fields
    if (!organizationName) {
      toast.error("Organization name is required.");
      return;
    }
    if (!organizationBRN) {
      toast.error("Organization BRN is required.");
      return;
    }
    if (!organizationOwnerName) {
      toast.error("Owner Name is required.");
      return;
    }
    if (!organizationPrefix) {
      toast.error("Organization Prefix is required.");
      return;
    }

    const formData = {
      organization_name: organizationName,
      organization_BRN: organizationBRN,
      owner_name: organizationOwnerName,
      organization_prefix: organizationPrefix,
    };

    const apiUrl = `${API_BASE_URL}/organizations/add`;

    try {
      const response = await axios.post(apiUrl, formData, {
        headers: {
          "Content-Type": "application/json", // Use JSON instead of multipart/form-data
        },
      });

      const { message, organization } = response.data;
      toast.success(message || "Organizations added successfully!"); // Display success toast
      console.log("Organizations added successfully!");

      // Set the generated unit code from the response
      setGeneratedOrganizationCode(organization.organization_code);
    } catch (error) {
      
      console.error("Error adding organization:", error);
      toast.error("Error adding organization. Please try again."); // Display error toast

    }
  };



  return (
    <div className="container mx-auto p-6">
      <div className="bg-white rounded-lg shadow-lg p-6 mt-4">
        <div>
          <h2 className="text-2xl font-bold text-green-700 mb-6">
            Add Organization
          </h2>
          {/* Left Column */}
          <div>
            <div className="mb-4">
              <label className="block text-gray-700 mb-2">
                Organization Name
              </label>
              <input
                type="text"
                className="w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
                placeholder="Enter organization name"
                value={organizationName}
                onChange={(e) => setOrganizationName(e.target.value)}
              />
            </div>
          </div>
          <div>
            <div className="mb-4">
              <label className="block text-gray-700 mb-2">
                Organization BRN
              </label>
              <input
                type="text"
                className="w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
                placeholder="Enter organization BRN"
                value={organizationBRN}
                onChange={(e) => setOrganizationBRN(e.target.value)}
              />
            </div>
          </div>
          <div>
            <div className="mb-4">
              <label className="block text-gray-700 mb-2">
                Organization Owner Name
              </label>
              <input
                type="text"
                className="w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
                placeholder="Enter organization owner name"
                value={organizationOwnerName}
                onChange={(e) => setOrganizationOwnerName(e.target.value)}
              />
            </div>
          </div>
          <div>
            <div className="mb-4">
              <label className="block text-gray-700 mb-2">
                Organization Code Prefix
              </label>
              <input
                type="text"
                className="w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
                placeholder="Enter organization owner name"
                value={organizationPrefix}
                onChange={(e) => {
                  const value = e.target.value.toUpperCase(); // Convert input to uppercase
                  if (/^[A-Z]*$/.test(value) && value.length <= 3) {
                    setOrganizationPrefix(value); // Allow only uppercase letters up to 3 characters
                  }
                }}
              />
            </div>
          </div>
          {/* Display the generated organization code if available */}
          {generatedOrganizationCode && (
            <div className="mt-4 p-4 bg-gray-100 rounded-lg">
              <p className="text-green-700 font-bold">
                Generated Organization Code: {generatedOrganizationCode}
              </p>
            </div>
          )}
        </div>
        {/* {toast.error && <p className="text-red-500">{toast.error}</p>}
        {toast.message && <p className="text-green-500">{toast.message}</p>} */}
        <div className="mt-6 text-right">
          <button
            onClick={handleAddOrganization}
            className="bg-green-700 text-white py-3 px-6 rounded-lg hover:bg-green-600 transition duration-300"
          >
            Add Organization
          </button>
        </div>
      </div>
    </div>
  );
}

export default AddOrganization;
